import Reveal from "@/components/base/Reveal";
import { downloadStats } from "@/mocks/homeData";

export default function DownloadCta() {
  return (
    <section id="download" className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-6">
        <Reveal>
          <div className="relative overflow-hidden rounded-lg bg-primary-950">
            <div className="absolute inset-0 opacity-30">
              <img
                src="https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20editorial%20background%20of%20soft%20glowing%20amber%20light%20streaks%20and%20blurred%20bokeh%20dots%20over%20a%20deep%20crimson%20charcoal%20surface%2C%20subtle%20film%20grain%2C%20no%20people%2C%20no%20text%2C%20clean%20minimal%20composition%2C%20cinematic%20wide%20gradient%20texture&width=1600&height=700&seq=hll-download-01&orientation=landscape"
                alt="客户端下载背景 · 暖色光影"
                title="黑料国产 客户端下载"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950 via-primary-950/90 to-primary-950/60"></div>

            <div className="relative grid gap-8 p-6 md:grid-cols-12 md:items-center md:p-10 lg:p-12">
              <div className="md:col-span-7">
                <span className="inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-white/5 px-3 py-1 text-xs text-accent-300">
                  <span className="flex h-3.5 w-3.5 items-center justify-center">
                    <i className="ri-smartphone-line"></i>
                  </span>
                  客户端 / 网页版入口
                </span>
                <h2 className="mt-4 font-heading text-2xl font-black leading-tight text-background-50 md:text-[34px]">
                  更新一响，比刷帖还快
                </h2>
                <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-[15px]">
                  下载客户端后可以订阅你关注的达人，事件有进展会第一时间推送。不想装应用也行，网页版功能一样，登录后能同步收藏。
                </p>

                <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:items-center">
                  <a
                    href="#download"
                    className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-download-2-line"></i>
                    </span>
                    下载客户端
                  </a>
                  <a
                    href="#top"
                    className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/25 bg-white/5 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-white/10"
                  >
                    <span className="flex h-4 w-4 items-center justify-center">
                      <i className="ri-global-line"></i>
                    </span>
                    直接打开网页版
                  </a>
                </div>

                <div className="mt-7 grid grid-cols-3 gap-4 border-t border-white/10 pt-6">
                  {downloadStats.map((stat) => (
                    <div key={stat.id}>
                      <p className="font-heading text-lg font-bold text-background-50 md:text-xl">{stat.value}</p>
                      <p className="mt-0.5 text-[11px] text-background-300">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>

              <div className="md:col-span-5">
                <div className="mx-auto flex max-w-[280px] flex-col items-center rounded-lg border border-white/15 bg-white/5 p-6 backdrop-blur">
                  <span className="flex h-32 w-32 items-center justify-center rounded-md bg-background-50 text-primary-950">
                    <i className="ri-qr-code-line text-7xl"></i>
                  </span>
                  <p className="mt-4 text-sm font-medium text-background-50">扫码直达客户端</p>
                  <p className="mt-1.5 text-center text-[11px] leading-relaxed text-background-300">
                    演示用占位图形，正式上线后替换为真实下载码。
                  </p>
                  <div className="mt-4 flex items-center gap-2 rounded-full border border-white/15 px-3 py-1.5 text-[11px] text-accent-300">
                    <span className="flex h-3.5 w-3.5 items-center justify-center">
                      <i className="ri-shield-check-line"></i>
                    </span>
                    无广告预览版
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}